import React from "react";
import { FaTwitter, FaLinkedin, FaYoutube, FaInstagram, FaFacebook, FaTiktok, FaProductHunt, FaGithub, FaGoogle } from "react-icons/fa6";

const ICONS = {
  twitter: FaTwitter,
  x: FaTwitter,
  linkedin: FaLinkedin,
  youtube: FaYoutube,
  instagram: FaInstagram,
  facebook: FaFacebook,
  tiktok: FaTiktok,
  producthunt: FaProductHunt,
  github: FaGithub,
  google: FaGoogle,
};

// Renders a small platform glyph based on proof.source_platform.
const SourceBadge = ({ proof, className = "", size = 14, color }) => {
  if (!proof.source_platform) return null;
  const key = proof.source_platform.toLowerCase().replace(/\s+/g, "");
  const Icon = ICONS[key];
  if (!Icon) return null;
  return (
    <Icon
      className={className}
      style={{ width: size, height: size, color }}
      aria-label={proof.source_platform}
    />
  );
};

export default SourceBadge;
